import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Route } from "react-router-dom";
import SidebarForms from "./SidebarForms/SidebarForms.js";
import AdresDogrulama from "./AdresDogrulama";
import EczaneForm from "./EczaneForm";
import KodKontrol from "./SidebarForms/KodKontrol.js";
import ServisUcretPanel from "./SidebarForms/ServisUcretPanel.js";

export default function FormsRouter() {
  const [width, setWidth] = useState(window.innerWidth);
  const history = useHistory();

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  const onClickCloseForm = () => {
    history.push("/");
  };

  return (
    <>
      <Route
        exact
        path="/adres-arama"
        component={() => (
          <div className={isMobile ? "formStyle-mobile" : "formStyle"}>
            <i
              onClick={() => onClickCloseForm()}
              className="fas fa-minus formClose"
            ></i>
            <SidebarForms />
          </div>
        )}
      />

      <Route
        exact
        path="/eczane-arama"
        component={() => (
          <div className={isMobile ? "formStyle-mobile" : "formStyle"}>
            <i
              onClick={() => onClickCloseForm()}
              className="fas fa-minus formClose"
            ></i>
            <EczaneForm />
          </div>
        )}
      />

      <Route
        exact
        path="/adres-dogrulama/:id"
        component={() => (
          <div className={isMobile ? "formStyle-mobile" : "formStyle"}>
            <i
              onClick={() => onClickCloseForm()}
              className="fas fa-minus formClose"
            ></i>
            <AdresDogrulama />
          </div>
        )}
      />

      <Route
        exact
        path="/adres-dogrulama"
        component={() => (
          <div className={isMobile ? "formStyle-mobile" : "formStyle"}>
            <i
              onClick={() => onClickCloseForm()}
              className="fas fa-minus formClose"
            ></i>
            <KodKontrol />
          </div>
        )}
      />
    </>
  );
}
